import { motion } from "framer-motion";

const WA_URL =
  "https://wa.me/971553087187?text=" +
  encodeURIComponent("Hello BR Hospitality, I would like to discuss a hospitality project.");

const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.87 9.87 0 0 0 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2m0 18.03a8.1 8.1 0 0 1-4.13-1.13l-.3-.18-3.12.82.83-3.04-.2-.31a8.08 8.08 0 0 1-1.24-4.28c0-4.47 3.64-8.11 8.12-8.11 2.17 0 4.21.85 5.74 2.38a8.07 8.07 0 0 1 2.38 5.74c0 4.48-3.64 8.11-8.08 8.11m4.44-6.07c-.24-.12-1.44-.71-1.66-.79-.22-.08-.39-.12-.55.12-.16.24-.63.79-.77.95-.14.16-.28.18-.53.06-.24-.12-1.03-.38-1.96-1.21-.72-.64-1.21-1.44-1.35-1.68-.14-.24-.02-.37.11-.5.11-.11.24-.28.37-.42.12-.14.16-.24.24-.4.08-.16.04-.31-.02-.43-.06-.12-.55-1.32-.75-1.81-.2-.48-.4-.41-.55-.42h-.47c-.16 0-.43.06-.65.31-.22.24-.86.84-.86 2.05 0 1.21.88 2.37 1 2.53.12.16 1.72 2.63 4.18 3.69.58.25 1.04.4 1.4.52.59.19 1.12.16 1.54.1.47-.07 1.44-.59 1.64-1.16.2-.57.2-1.05.14-1.16-.06-.1-.22-.16-.47-.28" />
  </svg>
);

const WhatsAppButton = () => (
  <motion.a
    data-testid="whatsapp-chat-button"
    href={WA_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with BR Hospitality on WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.2, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    className="group fixed bottom-6 left-6 z-40 flex items-center gap-3"
  >
    <span className="w-14 h-14 rounded-full bg-ink border border-bronze/50 text-bronze flex items-center justify-center shadow-xl group-hover:bg-bronze group-hover:text-ink transition-colors duration-500">
      <WhatsAppIcon />
    </span>
    <span className="hidden md:block text-[10px] tracking-[0.25em] uppercase text-ivory bg-ink/90 border border-bronze/30 px-4 py-2 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500">
      Chat With Us
    </span>
  </motion.a>
);

export default WhatsAppButton;
